(() => {
  const productMain = document.querySelector('main[data-template^="product"]');
  if (!productMain) return;

  document.body.classList.add('aa-v2-product-page');

  const sourceAdd = productMain.querySelector('.buy-buttons-block button[name="add"]');
  const nativeForm = sourceAdd?.closest('form[action*="/cart/add"]');
  const giftRoot = productMain.querySelector('[data-aa-gift-option]');
  const toggle = giftRoot?.querySelector('[data-aa-gift-toggle]');
  const messageWrap = giftRoot?.querySelector('[data-aa-gift-message-wrap]');
  const message = giftRoot?.querySelector('[data-aa-gift-message]');
  const count = giftRoot?.querySelector('[data-aa-gift-count]');
  const error = giftRoot?.querySelector('[data-aa-gift-error]');
  const giftVariantId = 67344515170349;

  const giftSelected = () => Boolean(toggle?.checked);
  const giftMessage = () => message?.value.trim() || 'No message provided';
  const productTitle = () => productMain.querySelector('h1')?.textContent?.trim() || 'Saree';
  const productQuantity = () => Math.max(1, Number(nativeForm?.querySelector('[name="quantity"]')?.value || 1));
  const productVariantId = () => Number(nativeForm?.querySelector('[name="id"]')?.value || 0);

  const setFormProperty = (name, value) => {
    if (!nativeForm) return;
    let input = nativeForm.querySelector(`[data-aa-gift-property="${name}"]`);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = `properties[${name}]`;
      input.dataset.aaGiftProperty = name;
      nativeForm.appendChild(input);
    }
    input.value = value;
  };

  const clearGiftProperties = () => {
    nativeForm?.querySelectorAll('[data-aa-gift-property]').forEach((input) => input.remove());
  };

  const applyGiftProperties = () => {
    setFormProperty('Gift box and wrapping', 'Yes');
    setFormProperty('Handwritten message', giftMessage());
  };

  const addGiftProduct = async (quantity) => {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{
          id: giftVariantId,
          quantity,
          properties: {
            'Gift wrapping for': productTitle(),
            'Handwritten message': giftMessage()
          }
        }]
      })
    });
    if (!response.ok) throw new Error('Gift box could not be added');
  };

  const showGiftError = () => {
    if (!error) return;
    error.textContent = 'Gift Box + Gift Wrapping could not be added. Please try again.';
    error.hidden = false;
  };

  let giftSubmissionInProgress = false;
  const submitNativeWithGift = async (submitter, control = submitter) => {
    if (!nativeForm || giftSubmissionInProgress) return;
    giftSubmissionInProgress = true;
    if (error) error.hidden = true;
    if (control) control.disabled = true;

    try {
      applyGiftProperties();
      await addGiftProduct(productQuantity());
      nativeForm.dataset.aaGiftPrepared = 'true';
      if (submitter) submitter.disabled = false;
      if (control && control !== submitter) control.disabled = false;
      nativeForm.requestSubmit(submitter || sourceAdd || undefined);
      window.setTimeout(() => delete nativeForm.dataset.aaGiftPrepared, 1500);
    } catch (exception) {
      if (submitter) submitter.disabled = false;
      if (control) control.disabled = false;
      showGiftError();
    } finally {
      giftSubmissionInProgress = false;
    }
  };

  let giftBuyNow;
  const setupGiftBuyNow = () => {
    const buttonArea = productMain.querySelector('.buy-buttons-block .product-form-buttons');
    if (!buttonArea || giftBuyNow) return;
    giftBuyNow = document.createElement('button');
    giftBuyNow.type = 'button';
    giftBuyNow.className = 'button aa-gift-buy-now';
    giftBuyNow.textContent = 'Buy now with gift wrapping';
    giftBuyNow.hidden = true;
    buttonArea.appendChild(giftBuyNow);

    giftBuyNow.addEventListener('click', async () => {
      const variantId = productVariantId();
      if (!variantId) return showGiftError();
      giftBuyNow.disabled = true;
      if (error) error.hidden = true;

      try {
        const quantity = productQuantity();
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [
              {
                id: variantId,
                quantity,
                properties: {
                  'Gift box and wrapping': 'Yes',
                  'Handwritten message': giftMessage()
                }
              },
              {
                id: giftVariantId,
                quantity,
                properties: {
                  'Gift wrapping for': productTitle(),
                  'Handwritten message': giftMessage()
                }
              }
            ]
          })
        });
        if (!response.ok) throw new Error('Gift checkout could not be prepared');
        window.location.assign('/checkout');
      } catch (exception) {
        giftBuyNow.disabled = false;
        showGiftError();
      }
    });
  };

  const syncGiftState = () => {
    const active = giftSelected();
    if (messageWrap) messageWrap.hidden = !active;
    productMain.classList.toggle('aa-gift-active', active);
    if (giftBuyNow) giftBuyNow.hidden = !active;
    if (!active) clearGiftProperties();
  };

  if (toggle && nativeForm) {
    setupGiftBuyNow();
    toggle.addEventListener('change', () => {
      syncGiftState();
      if (toggle.checked) message?.focus();
    });
    message?.addEventListener('input', () => {
      if (count) count.textContent = String(message.value.length);
      if (giftSelected()) applyGiftProperties();
    });

    nativeForm.addEventListener('submit', async (event) => {
      if (!giftSelected() || nativeForm.dataset.aaGiftPrepared === 'true') return;

      event.preventDefault();
      event.stopImmediatePropagation();
      const submitter = event.submitter;
      await submitNativeWithGift(submitter || sourceAdd);
    }, true);
    syncGiftState();
  }

  if (!sourceAdd) return;

  const sticky = document.createElement('div');
  sticky.className = 'aa-v2-sticky-buy';
  sticky.setAttribute('aria-label', 'Purchase this saree');
  sticky.setAttribute('aria-hidden', 'true');
  sticky.innerHTML = `
    <div class="aa-v2-sticky-buy__meta">
      <strong></strong>
      <span></span>
    </div>
    <button class="aa-v2-sticky-buy__add" type="button">Add to cart</button>`;

  sticky.querySelector('strong').textContent = productTitle();
  const stickyPrice = sticky.querySelector('.aa-v2-sticky-buy__meta span');
  const stickyAdd = sticky.querySelector('.aa-v2-sticky-buy__add');
  document.body.appendChild(sticky);

  const syncPurchaseState = () => {
    stickyPrice.textContent = productMain.querySelector('[data-product-price] .aa-bb__now')?.textContent?.trim() || '';
    stickyAdd.disabled = sourceAdd.disabled;
    stickyAdd.textContent = sourceAdd.disabled ? 'Unavailable' : giftSelected() ? 'Add with gift box' : 'Add to cart';
  };

  toggle?.addEventListener('change', syncPurchaseState);
  stickyAdd.addEventListener('click', async () => {
    if (giftSelected()) {
      await submitNativeWithGift(sourceAdd, stickyAdd);
      return;
    }
    sourceAdd.click();
  });
  new MutationObserver(syncPurchaseState).observe(sourceAdd, {
    attributes: true,
    attributeFilter: ['disabled']
  });

  const visibilityObserver = new IntersectionObserver(([entry]) => {
    const show = !entry.isIntersecting && !sourceAdd.disabled;
    sticky.classList.toggle('is-visible', show);
    sticky.setAttribute('aria-hidden', String(!show));
    document.body.classList.toggle('aa-sticky-active', show);
  }, { threshold: 0.01 });

  visibilityObserver.observe(sourceAdd);
  syncPurchaseState();
})();
